/* Juicy Chemistry - Testimonials page behaviour */
(()=>{
class JctCarousel extends HTMLElement{
connectedCallback(){
const t=this.track=this.querySelector('[data-track]');if(!t)return;
this.slides=[...t.children];this.i=0;
this.prevBtn=this.querySelector('[data-prev]');this.nextBtn=this.querySelector('[data-next]');
this.dots=[...this.querySelectorAll('[data-dot]')];
if(this.prevBtn)this.prevBtn.addEventListener('click',()=>this.go(this.i-1));
if(this.nextBtn)this.nextBtn.addEventListener('click',()=>this.go(this.i+1));
this.dots.forEach((d,n)=>d.addEventListener('click',()=>this.go(n)));
let to;t.addEventListener('scroll',()=>{clearTimeout(to);to=setTimeout(()=>{this.i=Math.round(t.scrollLeft/(t.clientWidth||1));this.update()},90)},{passive:true});
t.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();this.go(this.i+1)}if(e.key==='ArrowLeft'){e.preventDefault();this.go(this.i-1)}});
const ms=parseInt(this.dataset.autoplay||'0',10);
const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const editor=window.Shopify&&window.Shopify.designMode;
this.stop=()=>clearInterval(this.timer);
if(ms>0&&!reduce&&!editor&&this.slides.length>1){
const start=()=>{this.stop();this.timer=setInterval(()=>this.go(this.i>=this.slides.length-1?0:this.i+1),ms)};
['mouseenter','focusin','touchstart'].forEach(ev=>this.addEventListener(ev,this.stop,{passive:true}));
['mouseleave','focusout'].forEach(ev=>this.addEventListener(ev,start));
start();}
this.update();}
disconnectedCallback(){if(this.stop)this.stop()}
go(n){const max=this.slides.length-1;n=Math.max(0,Math.min(n,max));this.i=n;this.track.scrollTo({left:this.slides[n].offsetLeft,behavior:'smooth'});this.update()}
update(){this.slides.forEach((s,n)=>{const on=n===this.i;s.setAttribute('aria-hidden',on?'false':'true');s.inert=!on});
this.dots.forEach((d,n)=>d.setAttribute('aria-current',n===this.i?'true':'false'));
if(this.prevBtn)this.prevBtn.disabled=this.i===0;if(this.nextBtn)this.nextBtn.disabled=this.i===this.slides.length-1;}
}
class JctReviews extends HTMLElement{
connectedCallback(){
this.items=[...this.querySelectorAll('[data-review]')];
this.chips=[...this.querySelectorAll('[data-filter]')];
this.more=this.querySelector('[data-more]');this.live=this.querySelector('[data-live]');
this.step=parseInt(this.dataset.step||'9',10);this.shown=this.step;this.cat='all';
this.chips.forEach(c=>c.addEventListener('click',()=>{this.cat=c.dataset.filter;this.shown=this.step;this.chips.forEach(x=>x.setAttribute('aria-pressed',x===c?'true':'false'));this.render(true)}));
if(this.more)this.more.addEventListener('click',()=>{this.shown+=this.step;this.render(true)});
this.items.forEach(card=>{const b=card.querySelector('[data-readmore]');if(!b)return;b.addEventListener('click',()=>{const open=card.classList.toggle('is-open');b.setAttribute('aria-expanded',open?'true':'false');b.textContent=open?(b.dataset.less||'Read less'):(b.dataset.more||'Read more')})});
let rt;window.addEventListener('resize',()=>{clearTimeout(rt);rt=setTimeout(()=>this.clamp(),150)});
this.render(false);}
clamp(){this.items.forEach(card=>{if(card.hidden||card.classList.contains('is-open'))return;const t=card.querySelector('[data-clamp]'),b=card.querySelector('[data-readmore]');if(t&&b)b.hidden=t.scrollHeight<=t.clientHeight+2})}
render(announce){let n=0,total=0;
this.items.forEach(el=>{const ok=this.cat==='all'||el.dataset.cat===this.cat;if(ok)total++;const show=ok&&n<this.shown;if(show)n++;el.hidden=!show});
if(this.more)this.more.hidden=n>=total;
requestAnimationFrame(()=>this.clamp());
if(announce&&this.live)this.live.textContent='Showing '+n+' of '+total+' stories';}
}
if(!customElements.get('jct-carousel'))customElements.define('jct-carousel',JctCarousel);
if(!customElements.get('jct-reviews'))customElements.define('jct-reviews',JctReviews);
document.addEventListener('shopify:block:select',e=>{
const el=e.target;if(!el||!el.closest)return;
const c=el.closest('jct-carousel');if(c&&c.slides){const n=c.slides.indexOf(el);if(n>-1)c.go(n)}
if(el.matches&&el.matches('[data-review]'))el.hidden=false;});
})();
